<template>
  <a-modal
      title="批量设置同步素材"
      centered
      :width="480"
      :mask-closable="false"
      :visible="showBatchSyncForm"
      :confirmLoading="loading"
      @cancel="close"
  >
    <a-form-model
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="已选中">
        <span>{{ ids.length }} 人</span>
      </a-form-model-item>

      <a-form-model-item label="同步素材开关" required>
        <a-radio-group v-model="form.is_sync_material">
          <a-radio :value="1">开启同步</a-radio>
          <a-radio :value="0">关闭同步</a-radio>
        </a-radio-group>
      </a-form-model-item>

      <a-alert
        type="info"
        show-icon
        :message="form.is_sync_material ? '开启素材开关后，该优化师/剪辑的本地素材系统会自动同步到「系统设置->巨量组织管理」中「系统同步」状态为开启的组织。' : '关闭素材开关后，将不再自动同步该优化师/剪辑的本地素材。'"
      />
    </a-form-model>
    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
</style>

<script>
import BatchSync from './BatchSync'

export default BatchSync
</script>